<template>
<div class="new-body">
    <div class="new-content new-inr">
        <!-- Header 컴포넌트  -->
        <Header />

        <!-- Main Content -->
        <main id="new-container">
            <!-- Section1 SearchBar -->
            <section class="section-0 ">
                <div class="new-inrContent">
                    <h1><span class="font-engNum font-upper">No. 1</span> 고시원 정보 브랜드 <br> 고시원 쉽게 찾기</h1>
                    <span class="search-wrap">
                        <!-- 구글 자동완성 input 템플릿 -->
                        <vue-google-autocomplete id="map_search" classname="search-bar" placeholder="지역명, 지하철역명, 대학교명을 입력하세요." country="kr" types="" ref="searchBar" v-on:placechanged="getPlaceData" @keypress.enter="setPlaceBySubmit"></vue-google-autocomplete>
                        <button type="submit" @click="setPlaceBySubmit">
                            <figure class="icon-search"><img src="@/assets/new_images/icon-search.png" alt="검색아이콘">
                            </figure>
                            <span class="text-indent">검색</span>
                        </button>
                    </span>
                </div>
            </section>
            <!-- Section2 Popular and Notice -->
            <article class="section">
                <section class="section-1">
                    <div class="new-inrContent">
                        <div class="section-tit-wrap">
                            <h2>실시간 인기 고시원</h2>
                        </div>
                    </div>
                    <!-- Swiper -->
                    <div class="new-inrContent popular-swiper">
                        <div class="swiper popular-items-swiper">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" v-for="(item, idx) in rankingList" :key="'ranking_'+idx">
                                    <div class="popular-item">
                                        <a @click="goTo(item)">
                                            <figure class="popular-item__figure">
                                                <span class="popular-item__num">{{ item.ranking }}</span>
                                                <img :src="item.kosiwon.thumbnail_url" alt="실시간 인기 고시원 사진">
                                                <strong class="popular-item__name">{{ item.kosiwon.name }} {{ item.kosiwon.branch }}</strong>
                                            </figure>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section-2">
                    <div class="new-inrContent">
                        <div class="section-tit-wrap flex-b--c">
                            <h2>고시원 소식</h2>
                            <!-- <span class="more1">
                                <a href="">더보기</a>
                            </span> -->
                        </div>
                        <!-- rolling event -->
                        <div class="acme-news-ticker">
                            <div class="acme-news-ticker-box">
                                <ul class="rolling-event__wrap my-news-ticker">
                                    <li class="rolling-event__list flex-s--c wh-100" v-for="(item, idx) in textBannerList" :key="'text_'+idx">
                                        <a :href="item.target_url" target="_blank">
                                            <b class="font-engNum">{{item.title}}</b>
                                            {{item.sub_title}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            </article>

            <!-- Section3 추천 고시원 -->
            <KosiwonListComponents :kosiwonList="kosiwonList" />

            <!-- Section4 Large Banner -->
            <section class="section-3 section">
                <div class="new-inrContent">
                    <div class="section-tit-wrap flex-b--c">
                        <h2>휴식 News</h2>
                        <div class="swiper-pagination theme-swiper-pagination"></div>
                    </div>
                </div>
                <!-- Swiper -->
                <div class="swiper theme-swiper one-swiper">
                    <!-- <div class="swiper-button-prev theme-swiper-button-prev"></div> -->
                    <ul class="swiper-wrapper">
                        <li class="swiper-slide" v-for="(item, idx) in largeBannerList" :key="'large_'+idx">
                            <div class="theme-item">
                                <a :href="item.target_url" target="_blank">
                                    <figure class="theme-item__figure">
                                        <img :src="item.image_url" alt="테마별 고시원 사진">
                                    </figure>
                                    <dl>
                                        <dt>{{ item.title }}</dt>
                                        <dd>{{ item.sub_title }}</dd>
                                    </dl>
                                </a>
                            </div>
                        </li>
                    </ul>
                    <!-- <div class="swiper-button-next theme-swiper-button-next"></div> -->
                </div>
            </section>

            <!-- Section4 Small Banner -->
            <section class="section-5 section" style="display: none;">
                <div class="new-inrContent">
                    <div class="section-tit-wrap flex-b--c">
                        <h2>휴식 <span class="font-engNum">TIPS</span></h2>
                        <div class="swiper-pagination tips-swiper-pagination"></div>
                    </div>
                    <div class="swiper one-swiper tips-swiper">
                        <!-- <div class="swiper-button-prev tips-swiper-button-prev"></div> -->
                        <ul class="swiper-wrapper">
                            <li class="swiper-slide" v-for="(item, idx) in smallBannerList" :key="'small_'+idx">
                                <a :href="item.target_url" target="_blank">
                                    <figure><img :src="item.image_url" alt="휴식팁 샘플 이미지"></figure>
                                </a>
                            </li>
                        </ul>
                        <!-- <div class="swiper-button-next tips-swiper-button-next"></div> -->
                    </div>
                </div>
            </section>
        </main>

        <!-- Footer 컴포넌트  -->
        <Footer />

        <!-- MobileTab 컴포넌트 -->
        <MobileTab />

        <!-- ===================  Modal =================== -->
        <!-- <p><a href="#ex1" rel="modal">Open Modal</a></p> -->
        <div id="ex1" class="modal fade event-modal" v-if="eventBanner">
            <div class="new-modal-header flex-b--c ">
                <!-- <h3>{{eventBanner.title}}</h3> -->
                <a href="#" rel="modal:close" class="close-modal" id="closeBtn">
                    <span class="text-indent">Close</span>
                </a>
            </div>
            <div class="new-modal-content flex-b--c">
                <!-- <div class="new-modal-left" v-html="eventBanner.sub_title">
                </div> -->
                <div class="new-modal-right" @click="goToLink()">
                    <figure>
                        <!-- src="../assets/new_images/modal-img-sample.jpg"  -->
                        <!-- <div class="event-room-checkbox">
                            <input type="checkbox" id="eventCheckbox" @change="hideModal()">
                        </div> -->
                        <img :src="eventBanner.image_url" alt="이벤트 중인 고시원 사진">
                        <strong class="event-room-name" @click.stop="hideModal()">
                            일주일 동안 보지 않기
                        </strong>
                    </figure>
                </div>
            </div>
        </div>

        <!-- Loading Css -->
        <div class="loading-wrap">
            <svg class="tea" width="37" height="48" viewbox="0 0 37 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M27.0819 17H3.02508C1.91076 17 1.01376 17.9059 1.0485 19.0197C1.15761 22.5177 1.49703 29.7374 2.5 34C4.07125 40.6778 7.18553 44.8868 8.44856 46.3845C8.79051 46.79 9.29799 47 9.82843 47H20.0218C20.639 47 21.2193 46.7159 21.5659 46.2052C22.6765 44.5687 25.2312 40.4282 27.5 34C28.9757 29.8188 29.084 22.4043 29.0441 18.9156C29.0319 17.8436 28.1539 17 27.0819 17Z" stroke="var(--secondary)" stroke-width="2"></path>
                <path d="M29 23.5C29 23.5 34.5 20.5 35.5 25.4999C36.0986 28.4926 34.2033 31.5383 32 32.8713C29.4555 34.4108 28 34 28 34" stroke="var(--secondary)" stroke-width="2"></path>
                <path id="teabag" fill="var(--secondary)" fill-rule="evenodd" clip-rule="evenodd" d="M16 25V17H14V25H12C10.3431 25 9 26.3431 9 28V34C9 35.6569 10.3431 37 12 37H18C19.6569 37 21 35.6569 21 34V28C21 26.3431 19.6569 25 18 25H16ZM11 28C11 27.4477 11.4477 27 12 27H18C18.5523 27 19 27.4477 19 28V34C19 34.5523 18.5523 35 18 35H12C11.4477 35 11 34.5523 11 34V28Z">
                </path>
                <path id="steamL" d="M17 1C17 1 17 4.5 14 6.5C11 8.5 11 12 11 12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke="var(--secondary)"></path>
                <path id="steamR" d="M21 6C21 6 21 8.22727 19 9.5C17 10.7727 17 13 17 13" stroke="var(--secondary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        </div>
    </div>
</div>
</template>

<script>
import _ from "underscore";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import DynamicNavigator from "@/core/modules/DynamicNavigator";
import Url from "../utils/Url";

import Header from "@/components/New/Header";
import Footer from "@/components/New/Footer";

import KosiwonListComponents from "@/components/New/KosiwonList";

import MobileTab from "@/components/New/MobileTab";

import {
    mapState
} from "vuex";

export default {
    components: {
        VueGoogleAutocomplete,
        Header,
        Footer,
        KosiwonListComponents,
        MobileTab
    },
    data() {
        return {
            kosiwonList: [],
            rankingList: [],
            textBannerList: [],
            largeBannerList: [],
            smallBannerList: [],
            eventBanner: null
        }
    },
    computed: {
        ...mapState({
            pickItem: state => state.INTEREST.PICK_LIST
        }),
        ...mapState({
            centerState: state => state.MAPS.CENTER
        })
    },
    watch: {
        centerState(newVal) {
            setTimeout(() => {
                DynamicNavigator.getInstance().moveToMap(`/search?${Url.objectToQueryString(newVal)}`, this.$router)
            }, 100)
        }
    },
    async mounted() {
        this.$store.dispatch("setNetworkIndicator", false); // 기존 로딩 css -> false 설정
        document.querySelector(".loading-wrap").classList.add("on");
        document.querySelector("body").classList.add("loading");

        const res1 = await this.axios.get("/ranking");
        const res2 = await this.axios.get("/kosiwons/suggestion_v2");
        const res3 = await this.axios.get("/mainBanners");

        this.rankingList = res1.data.result; // 실시간 고시원 랭킹정보
        this.kosiwonList = res2.data.result; // 추천고시원 랭킹정보
        this.textBannerList = _.shuffle(res3.data.result.filter(item => item.type === "text")); // 고시원 소식 filter
        this.largeBannerList = _.shuffle(res3.data.result.filter(item => item.type === "large")); // 휴식 News filter
        this.smallBannerList = _.shuffle(res3.data.result.filter(item => item.type === "small")); // 휴식 Tips filter
        this.eventBanner = res3.data.result.filter(item => item.type === "event")[0]; // 휴식 Event filter

        this.kosiwonList.forEach(kosiwon => {
            this.pickItem.find(pick => {
                return kosiwon.isHeart = pick.pk === kosiwon.pk;
            });
        });

        this.$nextTick(() => {
            jQuery(document).ready(function ($) {
                $(".my-news-ticker").AcmeTicker({
                    type: "vertical",
                    direction: "right",
                    controls: {
                        prev: $(".acme-news-ticker-prev"),
                        toggle: $(".acme-news-ticker-pause"),
                        next: $(".acme-news-ticker-next")
                    }
                });
            })

            const tipsSwiper = new Swiper(".tips-swiper", {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                autoplay: {
                    delay: 3500,
                    disableOnInteraction: true,
                },
                navigation: {
                    nextEl: ".tips-swiper-button-next",
                    prevEl: ".tips-swiper-button-prev",
                },
                pagination: {
                    el: ".tips-swiper-pagination",
                    clickable: true,
                }
            })

            const themeSwiper = new Swiper(".theme-swiper", {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                autoplay: {
                    delay: 3500,
                    disableOnInteraction: true,
                },
                navigation: {
                    nextEl: ".theme-swiper-button-next",
                    prevEl: ".theme-swiper-button-prev",
                },
                pagination: {
                    el: ".theme-swiper-pagination",
                    clickable: true,
                },
            });

            const popularSwiper = new Swiper(".popular-items-swiper", {
                loop: true,
                loopAdditionalSlides: 1,
                slidesPerView: 2.1,
                spaceBetween: 10,
                autoplay: {
                    delay: 3500,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    650: {
                        slidesPerView: 4.1,
                        spaceBetween: 10,
                    }
                }
            });

            const slideScrollCnt = window.innerWidth > 650 ? 2 : 1;
            $('#slick1').slick({
                rows: 2,
                dots: false,
                arrows: true,
                infinite: true,
                draggable: true,
                swipe: true,
                speed: 300,
                slidesToShow: 2,
                slidesToScroll: slideScrollCnt,
                autoplay: true,
                autoplaySpeed: 3500,
                prevArrow: $("#aro1_prev"),
                nextArrow: $("#aro1_next"),
                responsive: [{
                    breakpoint: 550,
                    draggable: false,
                    settings: {
                        slidesToShow: 1,
                    }
                }]
            });

            const $self = this;
            $(".slide-item").on("mousedown", function () {
                $(".slide-item").on("mouseup mousemove", function handler(evt) {
                    if (evt.type === "mouseup") {
                        if (evt.target.className.indexOf("heart-includes") <= -1) {
                            const routeData = $self.$router.resolve(`/detail/${$(this).data("pk")}`);
                            DynamicNavigator.getInstance().moveToDetail(routeData.href, $self.$router);
                        }
                    }
                    $(".slide-item").off("mouseup mousemove", handler);
                });
            });
            setTimeout(() => {
                // 이벤트 배너가 존재하면서, 팝업 오픈 여부가 "N"이 아닌 경우
                if ($.cookie("popupYN") !== "N" && this.eventBanner) {
                    $("#ex1").modal("show");
                }

                document.querySelector(".loading-wrap").classList.remove("on");
                document.querySelector("body").classList.remove("loading");
            }, 50);
        });
    },
    methods: {
        hideModal() {
            // cookieName = "popupYN", cookieValue = "N", expires = 1 (1일)
            $.cookie("popupYN", "N", {
                expires: 7
            });
            $("#closeBtn").click();
        },
        goToLink() {
            window.open(this.eventBanner.target_url);
        },
        goTo(item) {
            const routeData = this.$router.resolve(`/detail/${item.kosiwon_pk}`);
            DynamicNavigator.getInstance().moveToDetail(routeData.href, this.$router);
        },
        setPlaceBySubmit() { // 직접 검색하여 들어올 경우
            const searchData = this.$refs.searchBar.autocompleteText;
            const places = new this.daum.maps.services.Places();

            if (searchData.trim() === "") {
                document.getElementById("map_search").focus();
                this.$refs.searchBar.autocompleteText = "";
            } else {
                places.keywordSearch(searchData, (result, status) => {
                    if (status === this.daum.maps.services.Status.OK && result.length > 0) {
                        this.getPlaceData({
                            latitude: result[0].y,
                            longitude: result[0].x
                        });
                    }
                });
            }
        },
        getPlaceData(place) { // 구글 자동 검색 사용하였을 때
            const latlng = {
                latitude: place.latitude,
                longitude: place.longitude
            }
            this.$store.dispatch('setMapCenter', latlng)
        }
    }
}
</script>
